import { Component } from '@angular/core';
import { Nav, NavController, NavParams, Events } from 'ionic-angular';

import { Attendance,  Permit,  Leave,  Overtime, PlanOvertime, PlanOvertimeBawahan } from '../';
import { DashboardPage as HomeProject } from '../../project_mobile/index';
import { HomePage as HomeAdvance } from '../../advance_mobile/index';
import { LoginMyRadiant } from '../../../providers';

@Component({
  selector: 'presensi-tabs',
  templateUrl: 'presensi.html'
})
export class AppPresensi {
  tab1Root: any = Attendance;
  tab2Root: any = Leave;
  tab3Root: any = Permit;
  tab4Root: any = Overtime;
  paramsPermit  = {
    isNotification:false,
  };
  paramsOvertime  = {
    isNotification:false,
  };
  mySelectedIndex :number = 0;

  constructor(public navCtrl: NavController, public nav: Nav, public navParams: NavParams, public loginProvider: LoginMyRadiant, public events: Events ) {    
    this.events.publish('user:check_login', false);
    this.mySelectedIndex = this.navParams['data']['tabIndex'];
    this.paramsPermit.isNotification = this.navParams.get('isNotificationPermit') == true ? true : false;
    this.paramsOvertime.isNotification = this.navParams.get('isNotificationOvertime') == true ? true : false;
    
  }

  goTo(menu){
    switch (menu) {
      case 'advance':
          this.nav.push(HomeAdvance);
        break;
      case 'project':
          this.nav.push(HomeProject);
        break;
      default:
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/presensi/presensiApp/presensi.ts